import {
  BreadcrumbsState,
  CrumbType,
} from 'b2b-apps/shop/breadcrumbs/redux/types';
import { State } from 'b2b-apps/shop/common/redux/types';

const getState = (state: State): BreadcrumbsState => state.breadcrumbs;

const getCrumbs = (state: State): CrumbType[] => getState(state).crumbs;

export {
  getCrumbs,
  getState,
};
